import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledPasswordInput from '../../../generic/Forms/LabeledPasswordInput';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import type { PipRepository } from '../../../../../typings/auth';

type RepositoryProps = {
  repository: PipRepository;
  onUpdateRepository: <K extends keyof PipRepository>(
    member: K,
    value: PipRepository[K],
  ) => void;
  onRemoveRepository: () => void;
};

const Repository: VoidFunctionComponent<RepositoryProps> = ({
  repository,
  onUpdateRepository,
  onRemoveRepository,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm" baselineAlignment>
      <LabeledTextInput
        labelVariant="legacy"
        label="URL"
        size="small"
        value={repository.url || ''}
        onChange={value => onUpdateRepository('url', value)}
        placeholder="https://github.com/org/repo"
      />
      <LabeledTextInput
        labelVariant="legacy"
        label="Username"
        size="small"
        value={repository.username || ''}
        onChange={value => onUpdateRepository('username', value)}
        placeholder="someuser"
      />
      <LabeledPasswordInput
        label="Password"
        size="small"
        value={repository.hasPassword ? '••••••••' : repository.password?.value || ''}
        onChange={value => onUpdateRepository('password', { __type: 's', value })}
      />
      <Button
        type="error"
        size="small"
        onClick={onRemoveRepository}
      >
        Remove
      </Button>
    </FormGroup>
  </div>
);

export default Repository;
